module.exports = __webpack_public_path__ + "static/media/1009907.d3844cf8.jpg";